import * as React from "react";
import { Button,Modal,Table,Input,message} from "antd";
import { connect } from "react-redux";

interface IActtachlistProps {
  id:any;
  label?: any;
  style?: any;
  mergelist?:any;
  submitTag:any;
  getOrderDetails:any;
}

// 修改
class Acttachlist extends React.Component<IActtachlistProps, any> {
  constructor(props: IActtachlistProps) {
    super(props);
  }
  state = {
    mergelist:[],
    visible:false,
    taoAccount:'',
    mallAccount:'',
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
 
  onChange = (row,value) =>{
    if(value instanceof Object){
      this.setState({
        [row]:value.target.value
      })
    }else{
      this.setState({
        [row]:value
      })
    }    
  }
  
  merge = (id) =>{
    const param: any = {
      id: this.props.id,
      type: 'surcharge',
      attach_id:id,
    }; 
    this.props.submitTag({
      ...param,
      callback: (data) => {
          this.handleCancel();
          message.success("合并成功")
          const params: any = {
            id: this.props.id
          }; 
          this.props.getOrderDetails({
            ...params,
            callback: () => {
              console.log(this.props);
            }
           });
      }
     });
  }

  mergelist(id) {
    const param: any = {
      id: id,
      type:'acttach',
      tao_account:this.state.taoAccount,
      mall_account:this.state.mallAccount,
    }; 
    this.props.mergelist({
      ...param,
      callback: (data) => {
        if(data instanceof Array){
          this.setState({
            mergelist: data
         });
         this.setState({
          visible:true
         })
        }
      }
     });
   }

 

  render() {
    const dataSource = this.state.mergelist;
    
    const columns = [{
      title: '序号',
      className: 'column-table',
      dataIndex: 'id',
      key: 'id',
      
    },{
      title: '订单编号',
      className: 'column-table',
      dataIndex: 'number',
      key: 'number',
    }, {
      title: 'SKU编号',
      className: 'column-table',
      dataIndex: 'sku_name',
      key:'sku_name',
    },{
      title: '下单日期',
      className: 'column-table',
      dataIndex: 'submit_date',
      key:'submit_date',
    }, {
      title: '出发日期',
      className: 'column-table',
      dataIndex: 'go_time',
      key: 'go_time',
    }, {
      title: '数量',
      className: 'column-table',
      dataIndex: 'num',
      key: 'num',
    }, {
      title: '成人',
      className: 'column-table',
      dataIndex: 'adult',
      key: 'adult',
    }, {
      title: '儿童',
      className: 'column-table',
      dataIndex: 'children',
      key: 'children',
    }, {
      title: '婴儿',
      className: 'column-table',
      dataIndex: 'baby',
      key: 'baby',
    }, {
      title: '操作',
      className: 'column-table',
      dataIndex: 'id',
      key: 'id',
      render: (text, row, index) => {
        return (
          <React.Fragment>
             <a onClick={this.merge.bind(this,row['id'])}>合并</a>  
          </React.Fragment>
        );
      }
    }];
    return (
      <React.Fragment>
      <Button onClick={this.mergelist.bind(this,this.props.id)} >关联补差</Button>
      <Modal maskClosable={false} onCancel={this.handleCancel} title="补差订单" visible={this.state.visible} footer={null} width="auto" centered={true}>
      <div className="mode-search">
           <label>淘宝账号</label><span className="mode-span"><Input onChange={this.onChange.bind(this,'taoAccount')}  /></span><label>商城账号</label><span className="mode-span"><Input onChange={this.onChange.bind(this,'mallAccount')}  /></span> <Button onClick={this.mergelist.bind(this,this.props.id)} type="primary" icon="search">搜索</Button>
      </div>
      <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
      </Modal>
      </React.Fragment> 
    );
  }
}
const mapState = state => ({
  id: state.orderDetails.id,
});
const mapDispatch = dispatch => {
  return {
    submitTag:dispatch.orderDetails.submitTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
    mergelist: dispatch.orderDetails.mergelist,
  };
};

export default connect(
  mapState,
  mapDispatch
)(Acttachlist);
